module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container",
    attrs: {
      "id": "product"
    }
  }, [_c('div', {
    staticClass: "product-wrapper"
  }, [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('el-row', {
    staticClass: "text-left"
  }, [_c('h1', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.content.title)
    }
  })]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "gallery"
  }, [_c('flickity', {
    ref: "flickity",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, [_vm._l((_vm.content.images), function(img) {
    return [_c('div', {
      staticClass: "carousel-cell"
    }, [_c('img', {
      attrs: {
        "src": _vm.transpileImage(img.src),
        "alt": ""
      }
    })])]
  })], 2)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-left",
    attrs: {
      "span": 11
    }
  }, [_c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.content.body)
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "aside",
    attrs: {
      "span": 12,
      "offset": 1
    }
  }, [(this.videoSrc) ? _c('div', {
    staticClass: "video"
  }, [_c('video', {
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": this.videoSrc,
      "type": "video/mp4"
    }
  })])]) : _vm._e()])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c58dd3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Product.vue
// module id = 142
// module chunks = 1